export default __webpack_public_path__ + "static/media/banner-default.f367462e.png";